/* Native filters and non-zooming product gallery. No third-party filter runtime. */
(() => {
  function init(root=document){
    root.querySelectorAll('[data-jv-facet-root]').forEach(scope=>{
      if(scope.dataset.ready)return;scope.dataset.ready='true';
      const drawer=scope.querySelector('.jv-facet-drawer'),opener=scope.querySelector('[data-jv-open-facets]'),backdrop=scope.querySelector('.jv-facet-backdrop');
      if(!drawer)return;
      scope.querySelector('form').addEventListener('submit',()=>{
        scope.querySelectorAll('input[type=range]').forEach(input=>{
          if((input.hasAttribute('data-jv-price-min')&&Number(input.value)===Number(input.min))||
             (input.hasAttribute('data-jv-price-max')&&Number(input.value)===Number(input.max)))input.disabled=true;
        });
      });
      const mobile=()=>matchMedia('(max-width:767px)').matches;
      const close=()=>{
        drawer.classList.remove('is-open');drawer.removeAttribute('role');drawer.removeAttribute('aria-modal');
        document.body.classList.remove('jv-facets-open');backdrop.hidden=true;
        opener.setAttribute('aria-expanded','false');
        drawer.querySelectorAll('details[open]').forEach(d=>d.open=false);
        opener.focus();
      };
      opener.addEventListener('click',()=>{
        drawer.classList.add('is-open');drawer.setAttribute('role','dialog');drawer.setAttribute('aria-modal','true');drawer.setAttribute('aria-label','Produkte filtern');
        document.body.classList.add('jv-facets-open');backdrop.hidden=false;opener.setAttribute('aria-expanded','true');
        drawer.querySelector('[data-jv-close-facets]').focus();
      });
      scope.querySelectorAll('[data-jv-close-facets]').forEach(b=>b.addEventListener('click',close));
      scope.querySelectorAll('[data-jv-facet-back],[data-jv-facet-apply]').forEach(b=>b.addEventListener('click',e=>{
        if(b.hasAttribute('data-jv-facet-back')||mobile()){
          e.preventDefault();const detail=b.closest('details');detail.open=false;detail.querySelector('summary').focus();
        }
      }));
      drawer.querySelectorAll('details').forEach(d=>d.addEventListener('toggle',()=>{
        if(d.open)drawer.querySelectorAll('details[open]').forEach(other=>{if(other!==d)other.open=false});
      }));
      document.addEventListener('click',e=>{
        if(!mobile())drawer.querySelectorAll('details[open]').forEach(d=>{if(!d.contains(e.target))d.open=false});
      });
      drawer.addEventListener('keydown',e=>{
        if(e.key==='Escape'){e.preventDefault();if(mobile()&&drawer.classList.contains('is-open'))close();else drawer.querySelectorAll('details[open]').forEach(d=>{d.open=false;d.querySelector('summary').focus()});}
        if(e.key==='Tab'&&drawer.classList.contains('is-open')){
          const focusable=[...drawer.querySelectorAll('button,a[href],input,summary,select')].filter(el=>!el.disabled&&el.getClientRects().length);
          const first=focusable[0],last=focusable.at(-1);
          if(e.shiftKey&&document.activeElement===first){e.preventDefault();last.focus()}
          else if(!e.shiftKey&&document.activeElement===last){e.preventDefault();first.focus()}
        }
      });
      matchMedia('(max-width:767px)').addEventListener('change',()=>{if(drawer.classList.contains('is-open'))close()});
    });
    root.querySelectorAll('[data-jv-gallery]').forEach(gallery=>{
      if(gallery.dataset.ready)return;gallery.dataset.ready='true';
      const syncSelection=()=>{
        const image=gallery.querySelector('img');if(!image)return;
        const path=new URL(image.src,location.href).pathname;
        gallery.parentElement.querySelectorAll('[data-jv-image]').forEach(b=>b.setAttribute('aria-pressed',String(new URL(b.dataset.jvImage,location.href).pathname===path)));
      };
      syncSelection();
      gallery.closest('[data-jv-product]').querySelector('[data-jv-variant]')?.addEventListener('change',()=>queueMicrotask(syncSelection));
      let start;
      gallery.addEventListener('touchstart',e=>{start={x:e.changedTouches[0].clientX,y:e.changedTouches[0].clientY}},{passive:true});
      gallery.addEventListener('touchend',e=>{
        if(!start)return;const dx=e.changedTouches[0].clientX-start.x,dy=e.changedTouches[0].clientY-start.y;start=null;
        if(Math.abs(dx)<45||Math.abs(dx)<Math.abs(dy)*1.5)return;
        const thumbs=[...gallery.parentElement.querySelectorAll('[data-jv-image]')];if(thumbs.length<2)return;
        const current=thumbs.findIndex(t=>t.getAttribute('aria-pressed')==='true');
        thumbs[(Math.max(current,0)+(dx<0?1:-1)+thumbs.length)%thumbs.length].click();
      },{passive:true});
    });
    // Retain every real specification, only improve its semantic layout.
    root.querySelectorAll('.pdp-accordions .jv-rte ul').forEach(list=>{
      const items=[...list.children];
      if(!items.length||!items.every(li=>li.tagName==='LI'&&li.textContent.includes(':')&&!li.querySelector('a,img')))return;
      const dl=document.createElement('dl');dl.className='pdp-spec-list';
      items.forEach(li=>{
        const text=li.textContent.trim(),at=text.indexOf(':'),row=document.createElement('div'),dt=document.createElement('dt'),dd=document.createElement('dd');
        row.className='pdp-spec-row';dt.textContent=text.slice(0,at).trim();dd.textContent=text.slice(at+1).trim();row.append(dt,dd);dl.append(row);
      });list.replaceWith(dl);
    });
  }
  init();document.addEventListener('shopify:section:load',e=>init(e.target));
  document.addEventListener('shopify:section:unload',()=>document.body.classList.remove('jv-facets-open'));
})();
